/*
 * @Author: liuyongjun
 * @Date: 2023-02-07 09:47:12
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-04-18 14:41:46
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/i18n/langs/zh.js
 */
export default {
  zh: {
    message: {
      hello: '你好',
      FlightDynamics: '航班动态'
    },
    crewMeal: {
      title: '机组选餐',
      choosedate: '请选择日期',
      choose: '请选择',
      confirm: '确定',
      cancel: '取消',
      submit: '提交',
      complete: '完成',
      ground: '地面就餐',
      board: '机上配餐',
      isSubmit: '是否确认提交?',
      success: '提交成功',
      fail: '提交失败',
      chooseMeal: '配餐选择'
    },
    common: {
      nodata: '暂无数据'
    }
  }
}
